import { useEffect, useState } from "react";
import api from "./api";

/**
 * Kept apart from `planRequired.js`, which `api.js` imports: this one imports `api`.
 *
 * D476 F3, F6: does this account sit behind the paywall right now? True only when the server says billing is
 * enforced and the account has no access. One read per page load, shared by every caller; a failed read answers
 * false and is not remembered, so nobody is told they need a plan on a guess. Test-only reset below.
 */
let paywallRead = null;
export function resetUnpaidPaywallRead() {
  paywallRead = null;
}
function readUnpaidPaywall() {
  if (!paywallRead) {
    paywallRead = Promise.resolve()
      .then(() => api.get("/billing/status", { params: { probe: "paywall" } })) // the marker lets a journey stub tell this read from the card's own
      .then(({ data }) => data?.enforced === true && data?.grants_access !== true)
      .catch(() => {
        paywallRead = null;
        return false;
      });
  }
  return paywallRead;
}
export function useUnpaidPaywall() {
  const [unpaid, setUnpaid] = useState(false);
  useEffect(() => {
    let alive = true;
    readUnpaidPaywall().then((v) => {
      if (alive) setUnpaid(v);
    });
    return () => {
      alive = false;
    };
  }, []);
  return unpaid;
}

export const AVAILABLE_WITH_PLAN = "Available once you have a plan";
export const INVITE_AFTER_PLAN = "Invite players after you choose a plan.";
